import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Countdown } from "@/components/Countdown";
import { MessageCircle } from "lucide-react";

export default function PublicLayout() {
  const [settings, setSettings] = useState(null);
  const location = useLocation();

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.post("/track", { path: location.pathname, event: "pageview" }).catch(() => {});
  }, [location.pathname]);

  const wa = settings?.whatsapp || "33760001096";
  const waText = encodeURIComponent("Bonjour, je souhaite réserver un set loulav & etrog.");
  const outletContext = useMemo(() => ({ settings }), [settings]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Countdown target={settings?.event_datetime} open={settings?.shop_open} />
      <Header settings={settings} />
      <main className="flex-1">
        <Outlet context={outletContext} />
      </main>
      <Footer settings={settings} />

      <a
        href={`https://wa.me/${wa}?text=${waText}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Nous contacter sur WhatsApp"
        className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
}
